import React from 'react';
import PropTypes from 'prop-types';

const DistanceReadout = (props) => {
  const { distance } = props;

  if (distance) {
    return (
      <div className="DistanceReadout">
        <p>Total Distance: { distance } mi.</p>
      </div>
    );
  }

  return null;
};

DistanceReadout.propTypes = {
  distance: PropTypes.number,
};

export default DistanceReadout;



// WEBPACK FOOTER //
// ./map/components/DistanceReadout.js